import React from 'react';
import {
  Button,
  Layout,
  Spacer,
  IconButton,
  Container,
  SvgClose,
} from '@loomhq/lens';
import styles from './styles.module.less';
import iosAppIcon from 'img/logos/ios-app-icon.svg';
import { APP_STORE } from '../../../constants/routes';

const MobileAppCard = ({ onCloseClick }) => (
  <>
    <div className={styles.mobileAppCardWrapper}>
      <Layout>
        <Layout.Section width="auto">
          <Spacer left="medium" top="medium">
            <img src={iosAppIcon} />
          </Spacer>
        </Layout.Section>
        <Layout.Section>
          <Spacer top="medium" left="medium" right="small">
            <strong>Record, share, and watch on the go.</strong> The fastest way
            to record and instantly share a video from your iPhone and iPad.
          </Spacer>
        </Layout.Section>
        <Layout.Section width="auto">
          <Spacer right="small" top="small">
            <IconButton icon={<SvgClose />} onClick={onCloseClick} />
          </Spacer>
        </Layout.Section>
      </Layout>
      <Container padding="medium">
        <Button htmlTag="a" href={APP_STORE} variant="primary" hasFullWidth>
          Download the app
        </Button>
      </Container>
    </div>
    <div className={styles.mobileAppCardSpacer} />
  </>
);

export default MobileAppCard;
